import { Tooltip_Config, AxisConfig, SeriesLineStyle } from '@blade-sxp/file-cluster/pages/create-task/utils/commonChartConfig';
import { merge } from 'lodash';
import { langTextInit } from '@blade/common/utils/echartUtils';
import lang from '@blade-sxp/screen/lang/index';
langTextInit(lang);
const snapshotsEchartConfig = (vue) => {
    return {
        title: {
            text: vue.$t('graphSnapshotsTitle'),
            textStyle: {
                fontSize: 16
            },
            top: 16,
            left: 16
        },
        color: ['#FFB443', '#54A9FF', '#FC725A', '#5DC264', '#62CDD4', '#B00241', '#741DE2'],
        tooltip: {
            trigger: 'axis',
            formatter: (params) => {
                let renderDom = '';
                renderDom += `<div class='tooltip-title' >${params[0].name}<div>`;
                params.forEach(item => {
                    const formatNumber = (item.value.toString()).replace(/\B(?=(\d{3})+\b)/g, ',');
                    renderDom += `<div class='tooltip-content'>
            <div class='tooltip-header'>
              <span class='tooltip-color' style='background-color:${item.color}'></span>
              <span class='tooltip-name'>${item.seriesName + '&nbsp&nbsp'}</span>
            </div>  
            <span class='tooltip-number'>${formatNumber}</span>
          </div>
        `;
                });
                return renderDom;
            },
            ...Tooltip_Config
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            data: [],
            ...merge({}, AxisConfig, {
                axisLabel: {
                    align: 'center',
                }
            })
        },
        yAxis: {
            type: 'value',
            ...AxisConfig
        },
        series: [
            {
                name: '',
                type: 'line',
                // stack: 'Total',
                data: [],
                ...SeriesLineStyle,
            }
        ]
    };
};
export default snapshotsEchartConfig;
